// draws.ts — Step 3c. Draw-request methods (surfaces the 010.C backend).
// See workers/core-os/src/routes/draws.ts (draw_requests, migration 0034).

import { request } from './request'

export interface DrawRequestRow {
  id: string
  project_id: string
  draw_number: number
  submitted_to_title_at: string | null
  total_requested_cents: number | null
  status: string
  title_company: string | null
  funded_at: string | null
  total_funded_cents: number | null
  notes: string | null
  gmail_draft_id: string | null
  gmail_draft_url: string | null
  // Patch 010.C.2.3 — GC fee split + compile/closeout tracking.
  construction_cost_requested_cents?: number | null
  gc_fee_amount_cents?: number | null
  is_final_draw?: number | null
  compiled_at?: string | null
  created_at: string
  updated_at: string | null
}

export interface DrawListResponse {
  ok: true
  draws: DrawRequestRow[]
  count: number
}

export interface CreateDrawInput {
  draw_number: number
  total_requested_cents: number
  title_company?: string
  notes?: string
}

export const drawsApi = {
  list: (projectId: string) =>
    request<DrawListResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/draw-requests`,
    ),
  create: (projectId: string, body: CreateDrawInput) =>
    request<{ ok: true; id: string; draw_number: number; status: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/draw-requests`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  update: (projectId: string, drawId: string, body: Record<string, unknown>) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${encodeURIComponent(projectId)}/draw-requests/${encodeURIComponent(
        drawId,
      )}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
}
